export const iconFontAwesomeNatureWind = (
	<i className="fa-solid fa-wind"></i>
);
